module.exports = __webpack_public_path__ + "static/media/mbox.7d303129.svg";